/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const copyObj = (value: any): any => {
  return JSON.parse(JSON.stringify(value));
};

export default copyObj;

